import { sectionFooter } from './textComponents';

export default () => `<section class="report-section">
<h2 class='section-title'>Activity</h2>
${sectionFooter('Notes from your Care Team', '...')}
</section>`;
